export * from './get-featured-ads';
